import React from "react"
import Select from "react-select"

const SaleItemPricing = ({ lists, evaluate, editType, editPrice, editFormula }) => {
    let types = ['Direct Price', 'Computed Price']
    
    return (
        <div className="font-bold mt-3">
            {
                lists.length > 0 ?
                    <table className="table-auto w-full mb-3">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-left">No</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">List</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Type</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Price</div>
                                </th>
                            </tr>
                        </thead>
                        {/* Table body */}
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                            {
                                lists.map((list, key) =>
                                    <tr>
                                        <td className="p-2 text-left">{key + 1}</td>
                                        <td className="p-2 text-left">{list?.name}</td>
                                        <td className="p-2 text-left">
                                            <Select
                                                className="w-40"
                                                value={{ label: list.type, value: list.type }}
                                                onChange={v => editType(v, key)}
                                                options={types.map(type => ({ label: type, value: type }))} />
                                        </td>
                                        <td className="p-2 text-left">
                                            {
                                                list?.type === 'Direct Price' ?
                                                    <input
                                                        className="appearance-none w-40 block bg-gray-200 text-center text-gray-700 border border-gray-200 rounded py-3 px-4 mr-2 leading-tight focus:outline-none focus:bg-white"
                                                        value={list?.price}
                                                        placeholder='Enter price'
                                                        onChange={e => editPrice(e.target.value, key)}
                                                        type="number" />
                                                :
                                                    <input
                                                        className="appearance-none w-40 block bg-gray-200 text-center text-gray-700 border border-gray-200 rounded py-3 px-4 mr-2 leading-tight focus:outline-none focus:bg-white"
                                                        defaultValue={list?.formula}
                                                        onChange={e => evaluate(e.target.value)}
                                                        placeholder='(bp * 1.33) + 100'
                                                        onBlur={e => editFormula(e.target.value, key)}
                                                        type="text" />
                                            }
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    :
                    <div className="text-center my-4">
                        <h3>Please use the price list section on the menu to add new price list.</h3>
                    </div>
            }
        </div>
    )
}

export default SaleItemPricing